export const languageMap = {
  'en': 1,
  'zh-CN': 2,
  'ru-RU': 3,
  'fr-FR': 4,
  'de': 5,
  'pt-PT': 6,
  'es-ES': 7
}
